function getTitle(vm) {
  const { pageTitle } = vm.$options;
  if (pageTitle) {
    return typeof pageTitle === 'function' ? pageTitle.call(vm) : pageTitle;
  }
}

function getEnvironmentString() {
  if (process.env.VUE_APP_API_BASE_URL.includes('localhost')) {
    return '[Local] ';
  }

  if (process.env.VUE_APP_ENVIRONMENT === 'development') {
    return '[Dev] ';
  }

  if (process.env.VUE_APP_ENVIRONMENT === 'staging') {
    return '[Staging] ';
  }

  if (process.env.VUE_APP_ENVIRONMENT === 'preview') {
    return '[Preview] ';
  }

  return null;
}

const titleMixin = {
  mounted() {
    this.updateTitle();
  },
  updated() {
    this.updateTitle();
  },
  methods: {
    updateTitle() {
      const title = getTitle(this);
      if (title) {
        document.title = `${getEnvironmentString() || ''}${title} | ParticleOne`;
      }
    }
  }
};

export default titleMixin;
